import { SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { setCompetitionParams } from '../util/interpolation-parameters.js';

/**
 * Mixin responsible for setting interpolation params on session change
 */
var CompetitionsMixin = /** @class */ (function (_super) {
    __extends(CompetitionsMixin, _super);
    function CompetitionsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.competitions = [];
        return _this;
    }
    CompetitionsMixin.prototype.sessionChange = function (isLoggedIn) {
        return __awaiter(this, void 0, void 0, function () {
            var user, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isLoggedIn) return [3 /*break*/, 2];
                        user = magic.session.getUser();
                        _a = this;
                        return [4 /*yield*/, magic.methods.competitions.all({
                                userName: user === null || user === void 0 ? void 0 : user.userName,
                            })];
                    case 1:
                        _a.competitions = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.competitions = [];
                        _b.label = 3;
                    case 3:
                        setCompetitionParams(this.competitions);
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], CompetitionsMixin.prototype, "sessionChange", null);
    CompetitionsMixin = __decorate([
        Component({})
    ], CompetitionsMixin);
    return CompetitionsMixin;
}(Mixins(MagicConfigMixin)));

export { CompetitionsMixin };
